import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';

@Component({
  selector: 'app-load-event-vehicle-assignation',
  templateUrl: './load-event-vehicle-assignation.component.html',
  styleUrls: ['./load-event-vehicle-assignation.component.scss']
})
export class LoadEventVehicleAssignationComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor() {
  }

  ngOnInit() {
  }

}
